import { AppStoreLinks } from '@/components/LoginPage/AppStoreLinks'
import { LoginForm } from '@/components/LoginPage/LoginForm'
import Logo, { LogoColorVariant } from '@/components/svgs/Logo'
import { Screen } from '@/ui/core/screen'
import { VStack } from '@/ui/core/stack'
import { Image } from 'expo-image'
import { View, useWindowDimensions } from 'react-native'
import Images from '#/assets/images/image-map'

const MobileLoginView = () => {
	return (
		<Screen preset="fixed" className="flex flex-1">
			<View className="flex-1 bg-palette_4">
				<Image
					source={Images.Smile}
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						width: '100%',
						height: '100%',
						opacity: 1,
					}}
					contentFit="cover"
				/>
				<View
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.6)',
					}}
				/>
				<VStack className="w-full h-full justify-end items-center">
					<View className="flex-1 justify-center items-center w-full">
						<Logo
							color={LogoColorVariant.BRIGHT}
							className="!w-full !h-full max-h-[40vh] rotate-90"
						/>
					</View>
					<VStack className="items-center w-[90%]">
						<LoginForm isMobile={true} />
						<View className="py-10">
							<AppStoreLinks />
						</View>
					</VStack>
				</VStack>
			</View>
		</Screen>
	)
}

const DesktopLoginView = () => {
	return (
		<Screen preset="fixed" className="bg-palette_1 h-full">
			<View className="flex-1 w-full justify-center items-center">
				<VStack className="w-[45%] max-w-[30em]">
					<VStack className="bg-palette_4 p-10 mt-10 gap-10">
						<Logo color={LogoColorVariant.BRIGHT} className="!w-full !h-full mb-9" />
						<LoginForm isMobile={false} />
					</VStack>
					<View className="w-[40%] mx-auto mt-10">
						<AppStoreLinks />
					</View>
				</VStack>
			</View>
		</Screen>
	)
}

export default function LoginScreen() {
	const { width } = useWindowDimensions()

	const showMobileView = width < 800

	return showMobileView ? <MobileLoginView /> : <DesktopLoginView />
}
